export default "__VITE_ASSET__CDtXd5OY__"